export const API_URL = "https://gnews.io/api/v4/search";
export const API_KEY = "25d2a031c12e91b6e9e9337b961e9ddb";
export const WEATHER_API = "https://api.openweathermap.org/data/2.5/weather";
export const WEATHER_KEY = "7ec2ccb3bfa08c0f1453f31897e28136";
export const WEATHER_ICON = "https://openweathermap.org/img/wn/";